import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName } from '../utils';

/** 順序 */
enum Order {
  asc = '1',
  desc = '2',
}

const nameConfig = {
  asc: new Map([
    [Locale.ja, '昇順'],
    [Locale.en, 'ASC'],
  ]),
  desc: new Map([
    [Locale.ja, '降順'],
    [Locale.en, 'DESC'],
  ]),
};

const toDisplay = enumToName(Order, nameConfig);
const toDisplayWithPrefix = enumToName(Order, nameConfig, { prefix: true });

export const order = {
  enum: Order,
  nameConfig,
  toDisplay,
  toDisplayWithPrefix,
};
export type { Order };
